import script from "./IndicadoresDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./IndicadoresDashboard.vue?vue&type=script&setup=true&lang=js"

import "./IndicadoresDashboard.vue?vue&type=style&index=0&id=14de2b21&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14de2b21"]])

export default __exports__